<template>
  <div class="services">
    <HeaderYellow
      anteTitle="Formations de qualité"
      title="Devenez Chauffeur de Taxi ou VTC"
      postTitle="Rejoignez notre Institut et lancez votre carrière dans le transport public particulier de personnes."
      :backgroundImage="require('@/assets/pictures/taxi-vtc.webp')"
    />
    <ServicesToggle />
  </div>
</template>

<script>
import HeaderYellow from "@/components/headers/HeaderYellow.vue";
import ServicesToggle from "@/components/services/ServicesToggle.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useMeta } from "vue-meta";
import { getServicesSeoData } from "@/components/services/servicesSeoData";
export default {
  components: { HeaderYellow, ServicesToggle },
  setup() {
    const route = useRoute();
    const metaInfo = computed(() => {
      const seoData = getServicesSeoData(route);

      return {
        title: seoData.title,
        description: [
          {
            content: seoData.description,
          },
        ],
        og: {
          title: seoData.title,
          description: seoData.description,
          url: seoData.canonical,
        },
        twitter: {
          title: seoData.title,
          description: seoData.description,
        },
        link: [
          {
            rel: "canonical",
            href: seoData.canonical,
          },
        ],
        script: seoData.jsonLd
          ? [
              {
                type: "application/ld+json",
                content: JSON.stringify(seoData.jsonLd),
              },
            ]
          : [],
      };
    });

    useMeta(metaInfo);
  },
  mounted() {
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      // Vérifier si la page est déjà en haut
      if (window.pageYOffset === 0) {
        return;
      }

      // Faire défiler vers le haut de la page
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>
